import type { DalError, DalReturn } from "@/core/dal/data.type";
import { dalDbOperation } from "@/core/dal/helper";
import type ApiService from "@/core/services/api.service";
import type APIEndpointsService from "@/core/services/api-endpoints.service";
import type { TermsAcceptData } from "@/core/types/terms-accept-data.type";

class TermsAcceptService {
	constructor(
		private apiService: ApiService,
		private apiEndpointsService: APIEndpointsService,
	) {}

	saveTermsAccept(data: TermsAcceptData): Promise<DalReturn<void, DalError>> {
		return dalDbOperation(() =>
			this.apiService.post<void>(
				this.apiEndpointsService.getRoutes().termsAccept.post(),
				data,
				{ skipAuth: true },
			),
		);
	}

	retrieveTermsAccept({
		user_id,
		terms_version,
	}: TermsAcceptData): Promise<DalReturn<{
		message: string;
		termsAcceptances: { terms_version: string } | null;
	}, DalError>> {
		return dalDbOperation(() =>
			this.apiService.get(
				this.apiEndpointsService.getRoutes().termsAccept.get(user_id),
				{ terms_version },
			),
		);
	}
}

export default TermsAcceptService;
